import Breadcrumb from "./components/Breadcrumb";
import UploadDocument from "./components/UpLoadDocument";
import PersonalInfo from "./components/PersonalInfo";

function PersonalDocument() {
    return (
        <>
        <Breadcrumb />
            <div className="personalDocumentContent">
                <div className="container">
                    <h5 className="title">
                        THÔNG TIN GIẤY TỜ
                    </h5>
                    <div className="row">
                        <div className="col-12 col-lg-4 col-md-5">
                            <UploadDocument />
                        </div>
                        <div className="col-12 col-lg-8 col-md-7">
                            <PersonalInfo />
                        </div>
                    </div>
                    </div>
            </div>
        </>
    );
}
export default PersonalDocument;